import { useCallback, useRef } from 'react';

import { sendEventToSegment } from 'redux/modules/analytics';

const EVENT = 'ME_user_activity';
const eachTwoMinutes = 120000;

const useActivity = ({ currentVersion }) => {
  const intervalRef = useRef();

  const sendEvent = useCallback(async () => {
    if (!currentVersion) {
      return;
    }
    await sendEventToSegment(EVENT, { currentVersion });
  }, [currentVersion]);

  const enableActivityHandler = useCallback(() => {
    sendEvent();
    const id = setInterval(sendEvent, eachTwoMinutes);
    intervalRef.current = id;
  }, [sendEvent]);

  const disableActivityHandler = useCallback(() => {
    clearInterval(intervalRef.current);
  }, []);

  return {
    enableActivityHandler,
    disableActivityHandler,
  };
};

export { useActivity, EVENT };
